import { useEffect, useState } from 'react';

/**
 * Current time in milliseconds, refreshed every `intervalMs`.
 * Use for relative labels ("2h ago", countdowns) that must not freeze on screen.
 */
export const useNow = (intervalMs = 60_000): number => {
  const [now, setNow] = useState(() => Date.now());

  useEffect(
    function tickNow() {
      const timer = setInterval(() => setNow(Date.now()), intervalMs);
      return () => clearInterval(timer);
    },
    [intervalMs],
  );

  return now;
};
